export class ContactFormTemplate {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  organization: string = '';
  body: string = '';
}
